import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import MenuItem from './MenuItem';
import MenuSubItem from './MenuSubItem';

const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 900px) {
    display: none;
  }
`;

const Menu = ({ activeMenu }) => {
  const { location } = useHistory();

  const isMenuItemActive = (path, pathname) => {
    if (!path || !pathname) {
      return false;
    }

    if (pathname === path) {
      return true;
    }

    if (pathname?.includes(path)) {
      return true;
    }

    return false;
  };

  const shouldRenderSublist = (path, pathname) => {
    if (!path || !pathname) {
      return false;
    }

    if (pathname?.includes(path)) {
      return true;
    }

    return false;
  };

  if (!isEmpty(activeMenu)) {
    return (
      <MenuContainer>
        {activeMenu?.map(({ title, checked, path, items }) => (
          <MenuItem
            key={uuid()}
            title={title}
            checked={checked}
            isActive={isMenuItemActive(path, location.pathname)}
          >
            {shouldRenderSublist(path, location.pathname) &&
              items?.map(({ title, checked, path }) => (
                <MenuSubItem
                  key={uuid()}
                  checked={checked}
                  title={title}
                  isActive={isMenuItemActive(path, location.pathname)}
                />
              ))}
          </MenuItem>
        ))}
      </MenuContainer>
    );
  }

  return null;
};

Menu.propTypes = {
  activeMenu: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Menu;
